import http from "../../backend/http.js";

async function createLog(log) {
  try {
    const response = await http.post("log-works", log);
    return response;
  } catch (err) {
    throw err;
  }
}

export { createLog };
